import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class DisputesService {
    modalTypes = {
        submittion: 'submittion',
        addMoreDocuments:'addMoreDocuments',
        upload_doc:"upload_doc"
      }
    constructor(
      ) { }
      
}